// extracted by mini-css-extract-plugin
var _1 = "NotificationModal__backdrop--k2GZb ModalGeneral__backdrop--gxZiG";
var _2 = "NotificationModal__bg--PBOJY ModalGeneral__bg--qeVmP";
var _3 = "NotificationModal__button--P8tzG";
var _4 = "NotificationModal__icon--Ig6at";
var _5 = "NotificationModal__iconContainer--HHmZp";
var _6 = "NotificationModal__main--dqmva";
var _7 = "NotificationModal__mainBeastBuilder--IsQvb";
var _8 = "NotificationModal__mainGiftReward--r2gSp";
var _9 = "NotificationModal__mainLeaderboards--y32qI";
var _a = "NotificationModal__mainRedesign--b8yU3";
var _b = "NotificationModal__text--HdmiG CoreGeneral__roboto--UlmjE fontSize__messageModal--yfbdg";
var _c = "NotificationModal__textLine--kbIXh";
var _d = "NotificationModal__textLineWithIcon--tZ8lw NotificationModal__textLine--kbIXh";
var _e = "NotificationModal__trophyUnlocked--ok3Vo";
export { _1 as "backdrop", _2 as "bg", _3 as "button", _4 as "icon", _5 as "iconContainer", _6 as "main", _7 as "mainBeastBuilder", _8 as "mainGiftReward", _9 as "mainLeaderboards", _a as "mainRedesign", _b as "text", _c as "textLine", _d as "textLineWithIcon", _e as "trophyUnlocked" }
